
import React, { useState } from 'react';
import './App.css';
import photos from './photos.json';

function App() {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const openModal = (photo) => {
    setSelectedPhoto(photo);
  };

  const closeModal = () => {
    setSelectedPhoto(null);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Eye of the Beholder</h1>
      </header>
      <div className="gallery">
        {photos.map(photo => (
          <div className="photo" key={photo.uri} onClick={() => openModal(photo)}>
            <img src={process.env.PUBLIC_URL + '/' + photo.uri} alt={photo.description} />
            <div className="photo-info">
              <p>{photo.description}</p>
            </div>
          </div>
        ))}
      </div>

      {selectedPhoto && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close" onClick={closeModal}>&times;</span>
            <img src={process.env.PUBLIC_URL + '/' + selectedPhoto.uri} alt={selectedPhoto.description} />
            <div className="modal-info">
              <p>{selectedPhoto.description}</p>
              <p>{new Date(selectedPhoto.timestamp * 1000).toLocaleDateString()}</p>
              {selectedPhoto.location && <p>{selectedPhoto.location}</p>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
